import React, { useEffect } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useClientSession } from '@/lib/ClientSessionContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { User, ShoppingBag, FileText, Image as ImageIcon, Database, LogOut, ChevronDown, LayoutDashboard } from 'lucide-react';
import MobileBottomNav from './MobileBottomNav';
import PublicNavbar from './PublicNavbar';

export default function ClientLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { clientUser, isLoadingClient, logoutClient, refreshClient } = useClientSession();

  useEffect(() => {
    if (!isLoadingClient && !clientUser) {
      navigate('/login?redirect=' + encodeURIComponent(location.pathname));
    } else if (clientUser) {
      refreshClient?.();
    }
  }, [clientUser, isLoadingClient, navigate, location.pathname]);

  const handleLogout = async () => {
    await logoutClient();
    navigate('/login');
  };

  const isInvoicePage = location.pathname.includes('/pesanan/') && !location.pathname.endsWith('/pesanan');

  if (isLoadingClient) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-[#F9F5EC]">
        <div className="w-8 h-8 border-4 border-[#D4AF37] border-t-[#302621] rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!clientUser) return null;

  return (
    <div className="min-h-screen bg-[#F9F5EC] text-[#4A3B32] font-sans">
      {/* Navbar Pintar untuk Client (Disembunyikan khusus pada halaman invoice detail) */}
      {!isInvoicePage && (
        <PublicNavbar />
      )}

      {/* Konten Halaman Client */}
      <main className={`container mx-auto px-4 py-8 ${isInvoicePage ? 'print:p-0' : ''} pb-36 md:pb-8`}>
        <Outlet />
      </main>

      {/* Mobile Bottom Navigation for Client */}
      {!isInvoicePage && (
        <MobileBottomNav 
          items={[
            { path: '/pesan-po', label: 'Buat PO', icon: ShoppingBag },
            { path: '/daftar-pesanan', label: 'Pesanan', icon: FileText },
            { path: '/', label: 'Home', icon: LayoutDashboard },
            { path: '/database-produk', label: 'Database', icon: Database },
            { path: '/profil-saya', label: 'Profil', icon: User },
          ]} 
        />
      )}
    </div>
  );
}
